module.exports = __webpack_public_path__ + "static/media/Maax-Regular.84517bef.ttf";